import { Flex } from "antd";
import { colors } from "shared/theme/color";
import { translate } from "shared/languages";
import { textPx } from "shared/constants/zoom";

interface RetentionMeterProps {
  matured: number;
  repeat: number;
  notYetMatured: number;
}

// A ratio against its own track, never a two-slice pie. Geometry follows
// ClassTypeSplitChart (height 14, fully rounded); the unfilled track is
// navyTint — a lighter step of the SAME ramp as the fill, so the state reads
// across the whole bar rather than fill-against-grey.
// The window this ratio covers is stated (and set) by the sentence the page
// renders directly beneath, so the meter no longer repeats it.
const RetentionMeter = ({ matured, repeat, notYetMatured }: RetentionMeterProps) => {
  const pct = matured > 0 ? Math.round((repeat / matured) * 1000) / 10 : null;

  return (
    <div>
      {/* An empty denominator is the normal case for a programme younger than
          the maturity window, so it gets a sentence rather than a 0% meter
          that would read as "nobody came back". */}
      {pct === null ? (
        <Flex
          vertical
          justify="center"
          style={{ minHeight: 96, color: colors.ink3, fontSize: textPx(13) }}
        >
          <span>{translate("analyticsPage.referral.retention_empty")}</span>
        </Flex>
      ) : (
        <>
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontSize: textPx(30),
              fontWeight: 600,
              letterSpacing: "-0.02em",
              fontVariantNumeric: "tabular-nums",
              color: colors.ink,
            }}
          >
            {`${pct}%`}
          </div>
          <div style={{ fontSize: textPx(13), color: colors.ink2, marginTop: 2, marginBottom: 14 }}>
            {`${repeat} ${translate("analyticsPage.referral.retention_of")} ${matured} ${translate("analyticsPage.referral.client_unit")}`}
          </div>
          <div
            style={{
              height: 14,
              borderRadius: 999,
              overflow: "hidden",
              background: colors.navyTint,
            }}
          >
            <div
              style={{
                width: `${Math.min(100, pct)}%`,
                height: "100%",
                background: colors.navy,
              }}
            />
          </div>
          {notYetMatured > 0 && (
            <div style={{ fontSize: textPx(12), color: colors.ink3, marginTop: 10 }}>
              {`${notYetMatured} ${translate("analyticsPage.referral.retention_excluded")}`}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RetentionMeter;
